module.exports = __webpack_public_path__ + "media/images/logo-white-5e639d1c853dc7398af3bf12a79482f8.svg";